import { formatDayLabel } from '../../../utils/formatDate';

function ProgramDaysNav({ datoer = [], activeDato, onSelectDato }) {
    return (
        <div className="program-days-nav" role="tablist" aria-label="Velg dag">
            {datoer.map(dato => (
                <button
                    key={dato}
                    type="button"
                    role="tab"
                    aria-selected={activeDato === dato}
                    className={`program-days-nav__item ${activeDato === dato ? 'is-active' : ''}`}
                    onClick={() => onSelectDato(dato)}
                >
                    {formatDayLabel(Number(dato))}
                </button>
            ))}
        </div>
    );
}

export default ProgramDaysNav;
